import React from "react";

import { getLogDisplayTime } from "../../utils/dashboardUtils";
import { getEventCardText } from "../../utils/ownerLine";

export default function EventPreview({ logs }) {
  const safeLogs = Array.isArray(logs) ? logs.slice(0, 3) : [];

  return (
    <div className="h-full space-y-2">
      {safeLogs.length === 0 ? (
        <div className="flex h-full min-h-[120px] items-center justify-center rounded-[18px] border border-rose-100 bg-white/80 text-sm text-gray-500 dark:border-rose-500/10 dark:bg-black/10 dark:text-gray-400">
          최근 이벤트가 없습니다.
        </div>
      ) : (
        safeLogs.map((log, idx) => {
          const displayTime = getLogDisplayTime(log);

          return (
            <div
              key={idx}
              className="rounded-[18px] border border-rose-100 bg-white/80 p-3 dark:border-rose-500/10 dark:bg-black/10"
            >
              <div className="flex items-center justify-between gap-2">
                <div className="inline-flex min-w-0 items-center gap-2">
                  <span className="h-2 w-2 shrink-0 rounded-full bg-rose-500" />
                  <span className="truncate text-[11px] font-semibold text-rose-500">
                    {log?.type || "EVENT"}
                  </span>
                </div>

                <span className="shrink-0 text-[10px] text-gray-400">
                  {displayTime || "-"}
                </span>
              </div>

              {/* "지점 / 팀 / 작업자 / 차량번호" + 사건 설명.
                  배지는 "⚠️ 안전장비 미착용" 까지만 알려줘서 안전모인지 안전대인지
                  구분이 안 된다. 설명을 빼면 정보가 줄어든다.
                  조립 규칙(장비명 중복 제거 포함)은 utils/ownerLine.js 에 있다. */}
              <div className="mt-2 line-clamp-2 text-[12px] font-medium text-gray-700 dark:text-gray-200">
                {getEventCardText(log) || "-"}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}